import { render, staticRenderFns } from "./send-email.vue?vue&type=template&id=4f96d4ec&scoped=true&"
import script from "./send-email.vue?vue&type=script&lang=js&"
export * from "./send-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f96d4ec",
  null
  
)

export default component.exports